import { Mime } from '@shared/api/common/mime-type';

export const PICTURE_STATUS_MEDIA_TYPE = "application/vnd.io.idaas.identity.api.picture.status.v2+json";

export const AVATAR_MIME_TYPES = [Mime.Jpeg, Mime.Png];
export const AVATAR_MIME_TYPES_STR = AVATAR_MIME_TYPES.join(",");

export enum PictureStatus {
  Pending = "PENDING",
  Verified = "VERIFIED",
  Rejected = "REJECTED",
}

export type PictureStatusResponse = {
  id: string;
  status: PictureStatus,
};
